module.exports = __webpack_public_path__ + "static/img/180x180-2.a6de705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/180x180-2.png
// module id = DOUT
// module chunks = 0